import { track } from "@amplitude/analytics-browser";
import { useAtom } from "jotai";
import { useCallback, useEffect } from "react";

import { isLocalEnvironment, isTestEnvironment } from "utils/environment";

import { eventStackAtom } from "../atoms/eventStack";
import { Event } from "../types/Event";

export const useEventTracking = () => {
  const [eventStack, setEventStack] = useAtom(eventStackAtom);

  const trackEvent = useCallback((event: Event) => {
    // Track events in unit tests but not on local dev instances
    if (isLocalEnvironment() && !isTestEnvironment()) {
      return;
    }

    if (navigator?.onLine) {
      track(event.name, event.properties);
    } else {
      setEventStack((events) => [...events, event]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (eventStack.length > 0 && navigator?.onLine) {
      eventStack.forEach((event) => {
        track(event.name, event.properties);
      });

      // Clear event stack
      setEventStack([]);
    }
  }, [eventStack, setEventStack]);

  return { trackEvent };
};
